// Angular imports
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

// Import component
import { LoaderComponent } from './loader/loader.component';

// Import service
import { LoaderService } from './loader.service';

@NgModule({
    declarations: [LoaderComponent],
    imports: [
        CommonModule
    ],
    exports: [
        LoaderComponent
    ]
})
export class LoaderModule {
    public static forRoot(): ModuleWithProviders<LoaderModule> {
        return  {
            ngModule: LoaderModule,
            providers: [ LoaderService ]
        }
    }

    constructor() {
        console.log('LoaderModule initialized');
      }
}
